import axiosInstance from "./Utils/axiosInstance";

export class ShiftWiseEmployees {
  static async getShiftWiseEmployeesData(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-data-service/1.0/shiftwiseEmployees",
        payload
      );
      return data
    } catch (error) {
      throw error;
    }
  }
}
